import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "document-details" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = {
  key: 0,
  class: "header flex flex-align-center"
}
const _hoisted_4 = {
  key: 0,
  class: "col33"
}
const _hoisted_5 = ["textContent"]
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "col33" }
const _hoisted_8 = ["textContent"]
const _hoisted_9 = { class: "mt-05" }
const _hoisted_10 = {
  key: 1,
  class: "col33"
}
const _hoisted_11 = ["textContent"]
const _hoisted_12 = { class: "mt-05" }
const _hoisted_13 = {
  key: 2,
  class: "flex flex-grow-1 flex-justify-end flex-align-end"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "versions"
}
const _hoisted_16 = { class: "header flex" }
const _hoisted_17 = ["textContent"]
const _hoisted_18 = ["textContent"]
const _hoisted_19 = { class: "version flex flex-align-center" }
const _hoisted_20 = { class: "col33" }
const _hoisted_21 = { class: "col33" }
const _hoisted_22 = { class: "flex flex-grow-1 flex-justify-end" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["textContent"]
const _hoisted_25 = { key: 2 }
const _hoisted_26 = ["textContent"]
const _hoisted_27 = { class: "batch" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("i", {
      class: "icons8-delete close",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideSheet && _ctx.hideSheet(...args)))
    }),
    _createElementVNode("h1", {
      textContent: _toDisplayString(_ctx.$t(_ctx.title))
    }, null, 8, _hoisted_2),
    (_ctx.detailDocument)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("i", {
            class: _normalizeClass(["big primary--text mr", _ctx.documentIcon])
          }, null, 2),
          (_ctx.detailDocument.documentType)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("b", {
                  textContent: _toDisplayString(_ctx.$t("DOCUMENTS.DOCUMENT_TYPE"))
                }, null, 8, _hoisted_5),
                _createElementVNode("div", {
                  class: "mt-05",
                  textContent: _toDisplayString(_ctx.$t(_ctx.documentTypeKey))
                }, null, 8, _hoisted_6)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("b", {
              textContent: _toDisplayString(_ctx.$t(_ctx.primaryName))
            }, null, 8, _hoisted_8),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.detailDocument.primaryValue), 1)
          ]),
          (_ctx.detailType === _ctx.documentDetailType.version)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("b", {
                  textContent: _toDisplayString(_ctx.$t(_ctx.secondaryName))
                }, null, 8, _hoisted_11),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.detailDocument.secondaryValue), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("button", {
                  class: "document-details__icon-button",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadDocument()))
                }, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("i", { class: "icons8-download accent--text" }, null, -1)
                ]))])
              ]))
        ]))
      : _createCommentVNode("", true),
    _cache[5] || (_cache[5] = _createElementVNode("hr", { class: "mt-2 mb-2" }, null, -1)),
    (_ctx.documentVersions && _ctx.detailType === _ctx.documentDetailType.version)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (_ctx.documentVersions.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("b", {
                    class: "col33",
                    textContent: _toDisplayString(_ctx.$t("DOCUMENTS.VERSION_NUMBER"))
                  }, null, 8, _hoisted_17),
                  _createElementVNode("b", {
                    class: "col33",
                    textContent: _toDisplayString(_ctx.$t("DOCUMENTS.UPLOAD_DATE"))
                  }, null, 8, _hoisted_18),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1))
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentVersions, (version, i) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, _toDisplayString((_ctx.documentVersions.length - i) + '.0'), 1),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.formatDate(version.versionDate, 'dd-MM-yyyy HH:mm')), 1),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("button", {
                        class: "document-details__icon-button",
                        type: "button",
                        onClick: ($event: any) => (_ctx.downloadVersion(version))
                      }, [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("i", { class: "icons8-download accent--text" }, null, -1)
                      ]))], 8, _hoisted_23)
                    ])
                  ]))
                }), 256))
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "no-results",
                textContent: _toDisplayString(_ctx.$t("DOCUMENTS.NO_VERSIONS_FOUND"))
              }, null, 8, _hoisted_24))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("b", {
            textContent: _toDisplayString(_ctx.$t(_ctx.secondaryName))
          }, null, 8, _hoisted_26),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batches, (batch) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(batch), 1))
          }), 256))
        ]))
  ]))
}